<template>
  <div>
    <b-row class="mb-1">
      <b-col cols="12">
        <b-form-group label="Период анализа (недель)">
          <b-form-radio-group
            v-model="weeksLimit"
            :options="weeksOptions"
            button-variant="outline-primary"
            buttons
            size="sm"
            name="finance-weeks-limit"
          />
        </b-form-group>
      </b-col>
    </b-row>

    <b-overlay :show="isLoading" rounded="sm">
      <finance-kpi-cards :kpis="kpis" />
      <finance-weekly-chart :points="points" />
      <b-row>
        <b-col cols="12" md="6" class="mb-1">
          <finance-top-hosts :hosts="topHosts" />
        </b-col>
        <b-col cols="12" md="6" class="mb-1">
          <finance-packs-roi-compact />
        </b-col>
      </b-row>
    </b-overlay>
  </div>
</template>

<script>
import {
  BRow, BCol, BFormGroup, BFormRadioGroup, BOverlay,
} from 'bootstrap-vue'
import { ref, watch } from '@vue/composition-api'
import store from '@/store'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import FinanceKpiCards from '@/views/finance/components/FinanceKpiCards.vue'
import FinanceWeeklyChart from '@/views/finance/components/FinanceWeeklyChart.vue'
import FinanceTopHosts from '@/views/finance/components/FinanceTopHosts.vue'
import FinancePacksRoiCompact from '@/views/finance/components/FinancePacksRoiCompact.vue'

export default {
  components: {
    BRow, BCol, BFormGroup, BFormRadioGroup, BOverlay,
    FinanceKpiCards, FinanceWeeklyChart, FinanceTopHosts, FinancePacksRoiCompact,
  },
  setup() {
    const toast = useToast()
    const weeksLimit = ref(12)
    const weeksOptions = [
      { text: '4 нед.', value: 4 },
      { text: '8 нед.', value: 8 },
      { text: '12 нед.', value: 12 },
      { text: '24 нед.', value: 24 },
      { text: '52 нед.', value: 52 },
      { text: '2 года', value: 104 },
      { text: '3 года', value: 156 },
    ]
    const isLoading = ref(false)
    const points = ref([])
    const kpis = ref(null)
    const topHosts = ref([])

    const fetchData = () => {
      isLoading.value = true
      store.dispatch('app-finance/fetchDashboard', { weeks_limit: weeksLimit.value })
        .then(response => {
          const d = response.data.data
          points.value = d.points || []
          kpis.value = d.kpis || null
          topHosts.value = d.top_hosts || []
        })
        .catch(err => {
          toast({
            component: ToastificationContent,
            props: {
              title: err.response?.data?.message || 'Ошибка загрузки финансового отчёта',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
        .finally(() => {
          isLoading.value = false
        })
    }

    watch(weeksLimit, fetchData)
    fetchData()
    // Перезапрос после пересборки серверного кеша (кнопка «Обновить» в шапке раздела)
    watch(() => store.state['app-finance'].refreshVersion, fetchData)

    return { weeksLimit, weeksOptions, isLoading, points, kpis, topHosts }
  },
}
</script>

